import { Input as InputAnt } from 'antd'
import { Field, FieldProps } from 'formik'
import { InputProps as InputPropsAnt } from 'antd/lib/input'
import { FormikFieldProps } from './FieldProps'
import { MaxCharactersWrapper } from './MaxCharactersWrapper'

export type InputProps = (FormikFieldProps & InputPropsAnt) & {
  showMaxCharacters?: {
    max: number
    description?: string
    warningText?: string
  }
}

export const Input = ({ name, validate, maxLength, showMaxCharacters, ...restProps }: InputProps): JSX.Element => {
  const input = (value, onChange) => (
    <InputAnt
      name={name}
      value={value}
      onChange={onChange}
      maxLength={showMaxCharacters ? showMaxCharacters.max : maxLength}
      {...restProps}
    />
  )

  return (
    <Field name={name} validate={validate}>
      {({ field: { value, onChange } }: FieldProps) =>
        showMaxCharacters ? (
          <MaxCharactersWrapper
            usedCharacters={value.length}
            maxCharacters={showMaxCharacters.max}
            maxCharactersDescription={showMaxCharacters.description}
            warningText={showMaxCharacters.warningText}
          >
            {input(value, onChange)}
          </MaxCharactersWrapper>
        ) : (
          input(value, onChange)
        )
      }
    </Field>
  )
}
